// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"cddb9aff","465":"5efefd30","535":"0a1cf795","982":"86233eee"}[chunkId] + ".chunk.css";
};